import { css } from 'styled-components'

import { features } from '@h2/components/media'
import { SG, SG90T, SLB, SLB90T, SO, SO90T, WHITE } from '@h2/components/colors'

const colors = {
  blue: SLB,
  green: SG,
  orange: SO
}
const lighterColors = {
  blue: SLB90T,
  green: SG90T,
  orange: SO90T
}
const getResponsiveStyles = ({ shade }) => {
  if (shade !== 'orange') {
    return null
  }

  return `
    @media (${features.minWidth.desktop}) {
      background-image: linear-gradient(
        to top right,
        ${WHITE} 0 70%,
        transparent 30% 100%
      ),
      radial-gradient(
        ellipse at 30px 170px,
        ${WHITE} 0 calc(100% / 1.2),
        ${SO} calc(100% / 1.19) 100%
      );
    }
  `
}
const backgroundCurve = css`
  background-image: linear-gradient(
      to top right,
      ${({ shade }) => lighterColors[shade]} 0 70%,
      transparent 30% 100%
    ),
    radial-gradient(
      ellipse at 30px 170px,
      ${({ shade }) => lighterColors[shade]} 0 calc(100% / 1.2),
      ${({ shade }) => colors[shade]} calc(100% / 1.19) 100%
    );
  ${getResponsiveStyles};
`

export { backgroundCurve }
